import React from "react";
import styles from "./customInput.module.scss";

const CustomInput = ({
  inputKey,
  label,
  value,
  onChange,
  type,
  placeholder,
  textArea,
  fullWidth,
}) => {
  const handleInputChange = (event) => {
    event.preventDefault();
    if (typeof onChange == 'function') {
      onChange(event?.target?.name, event?.target?.value)
    };
  };

  return (
    <div
      className={
        fullWidth ? styles.container + " " + styles.fullWidth : styles.container
      }
    >
      <div
        className={
          type === "radio"
            ? styles.wrapper + " " + styles.rowWrapper
            : styles.wrapper
        }
      >
        <label htmlFor={`outlined-input-${inputKey}`} className={styles.label}>
          {label}
        </label>
        {!textArea ? (
          <input
            className={styles.input}
            name={inputKey}
            id={`outlined-input-${inputKey}`}
            type={type}
            value={value}
            onChange={handleInputChange}
            placeholder={placeholder}
            required
          />
        ) : (
          <textarea
            className={styles.textArea}
            name={inputKey}
            id={`outlined-input-${inputKey}`}
            type={type}
            value={value}
            onChange={handleInputChange}
            placeholder={placeholder}
            rows="4"
          />
        )}
      </div>
    </div>
  );
};

export default CustomInput;
